import { DestructiveModal } from "../../../components/modal/Modal";
import { useTranslation } from "../../../state/i18n";
import { useModalManager } from "../../../components/modal/ModalManager";
import type CustomerId from "../../../state/CustomerId";
import type RoleId from "../../../state/RoleId";
import type { VoidComponent } from "solid-js";
import UserService from "../../../services/UserService";
import GenericFailureModal from "../../GenericFailureModal";

type DeleteRoleModalProps = {
  customerId: CustomerId;
  roleId: RoleId;
};

const DeleteRoleConfirmationModal: VoidComponent<DeleteRoleModalProps> = (props) => {
  const { t } = useTranslation();
  const { replace } = useModalManager();

  return (
    <DestructiveModal
      confirmLabel={t(($) => $.DELETE_ROLE_CONFIRMATION_MODAL_ACTIONS_CONFIRM)}
      confirmLabelSlow={t(($) => $.DELETE_ROLE_CONFIRMATION_MODAL_ACTIONS_CONFIRM_SLOW)}
      cancelLabel={t(($) => $.DELETE_ROLE_CONFIRMATION_MODAL_ACTIONS_CANCEL)}
      title={t(($) => $.DELETE_ROLE_CONFIRMATION_MODAL_TITLE)}
      description={t(($) => $.DELETE_ROLE_CONFIRMATION_MODAL_DESCRIPTION)}
      onConfirm={() => {
        const roleId = props.roleId;
        const customerId = props.customerId;

        return new Promise<void>((resolve, reject) =>
          UserService.deleteRole(customerId, roleId).mutate(undefined, {
            onSuccess: () => {
              resolve();
            },
            onError: (err) => {
              replace({
                content: () => <GenericFailureModal error={err} />,
              });
              reject(err);
            },
          }),
        );
      }}
    />
  );
};

export default DeleteRoleConfirmationModal;
